const styles = {
  dashboard: {
    display: 'flex',
    flexDirection: 'column'
  }
}

export default styles
